import React from "react";
import "@/App.css";
import Nav from "@/components/sections/Nav";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import Philosophy from "@/components/sections/Philosophy";
import About from "@/components/sections/About";
import Compliance from "@/components/sections/Compliance";
import FAQ from "@/components/sections/FAQ";
import Contact from "@/components/sections/Contact";
import Footer from "@/components/sections/Footer";
import FloatingWhatsApp from "@/components/sections/FloatingWhatsApp";

function App() {
  return (
    <div className="App min-h-screen bg-bone text-forest-900" data-testid="app-root">
      <Nav />
      <main>
        <Hero />
        <Services />
        <Philosophy />
        <About />
        <Compliance />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
